<template>
  <div class="learning-path-group">
    <div class="learning-path-group__wrapper">
      <p class="learning-path-group__order">{{ group.order }}</p>
      <h6 class="learning-path-group__title">{{ group.title }}</h6>
      <div
        v-if="isAuthenticated && userId"
        class="learning-path-group__progress-wrapper"
      >
        <radial-progress-bar
          :diameter="30"
          :strokeWidth="3"
          :completed-steps="groupProgress"
          startColor="#00DC9B"
          :total-steps="groupLength"
        ></radial-progress-bar>
        <p class="learning-path-group__completed">
          {{ groupProgress }}/{{ group.courses.length }}
        </p>
      </div>
    </div>
    <learning-path-course-groups
      v-for="course in group.courses"
      :key="course.id"
      :course="course"
      :backgroundImg="$getCourseBackground(course, 'small')"
      :fallbackImg="
        fallbackImages[Math.floor(Math.random() * fallbackImages.length)]
      "
      :courseDuration="$duration.getCourseDuration(course)"
      :isAuthenticated="isAuthenticated"
      :courseProgress="courseProgress(course)"
      :courseVideoCount="courseVideoCount(course)"
    ></learning-path-course-groups>
  </div>
</template>

<script>
import RadialProgressBar from 'vue-radial-progress'
import LearningPathCourseGroups from './LearningPathCourseGroups.vue'

export default {
  name: 'LearningPathGroup',
  data() {
    return {
      fallbackImages: [
        'https://s3.amazonaws.com/my.ine.com/assets/learning-areas/thumbs/general_thumb.jpg',
        'https://s3.amazonaws.com/my.ine.com/assets/learning-areas/thumbs/networking_thumb.jpg',
        'https://s3.amazonaws.com/my.ine.com/assets/learning-areas/thumbs/development_thumb.jpg',
      ],
    }
  },
  components: {
    RadialProgressBar,
    LearningPathCourseGroups,
  },
  props: {
    group: {
      type: Object,
      required: true,
    },
    isAuthenticated: {
      type: Boolean,
      required: false,
    },
    userId: {
      type: String,
      required: false,
    },
    progress: {
      type: Array,
      required: false,
    },
  },
  computed: {
    groupProgress() {
      let totalProgress = 0
      if (this.progress) {
        this.progress.map(progress => {
          if (progress.watched_videos - progress.total_videos === 0) {
            totalProgress++
          }
        })
      }
      return totalProgress
    },
    groupLength() {
      return this.group.courses.length
    },
  },
  methods: {
    courseProgress(course) {
      if (this.progress) {
        const match = this.progress.find(progress => progress.id === course.id)
        return match && match.length !== 0 ? match.watched_videos : 0
      }
      return 0
    },
    courseVideoCount(course) {
      return course && course.totalCourseVideos ? course.totalCourseVideos : 0
    },
  },
}
</script>

<style lang="scss" scoped>
.learning-path-group {
  display: flex;
  flex-wrap: wrap;
  &__wrapper {
    display: flex;
    align-items: center;
    width: 100%;
    background-color: var(--light-gray);
    height: 50px;
  }
  &__order {
    color: var(--white);
    font-size: 2.5rem;
    margin: 0;
    background-color: var(--black);
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0;
    @include mobile {
      padding: 0 25px;
    }
  }
  &__title {
    color: var(--white);
    font-size: 1.3rem;
    margin: 0 0 0 15px;
    @include mobile {
      margin: 0 30px;
    }
  }
  &__progress-wrapper {
    display: flex;
    align-items: center;
    margin: 0 5px 0 auto;
    @include mobile {
      margin: 0 50px 0 auto;
    }
  }
  &__completed {
    color: var(--white);
    margin: 0;
    margin-left: 5px;
  }
}
</style>
